/* eslint-disable */
import BASE from '../../../../vue.config.js'

const $ = require('jquery')

import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import Prism from 'vue-prism-component'
import listado from '../../../assets/js/ScriptListadoGeneral.js'


export default{
	data() {
		return {
			contadorSiguiente:0,
			contadorEdicion:0,
			settings: { // perfectscrollbar settings
				maxScrollbarLength: 60,
				wheelSpeed: .60,
			},
			selectedModalidad:[],
			selectedGrado:[],
			paginaCabecera:'',
			gradoEducativo:'',
			modalidades:'',

			idProgramaEducativo:0,
			idDetalleModalidad:0,

			resumenGradoEducativo:'',
			resumenProgramaEducativo:'',
			resumenModalidad:'',
			resumenDetalleModalidad:'',

			datosTablaGrados:[],
			datosTablaModalidades:[],

			GradoValidacion:'',
			ModalidadValidacion:'',
			idOferta:'',
			idModalidad:0



		}
},
	methods:{

		Guardar(){
		
			if (this.idOferta == 0){
				this.GuardarOferta();
			}else{ 
				this.EditarOferta();
			}
		},

		
		ObtenerInformacionPrograma(){
		
			fetch(`${BASE.baseUrl}api/FormularioOfertaEducativa`, {
		        method: 'GET',
		        headers: {
		        		   'Authorization': sessionStorage.getItem('token'),
		        		   'pagina':'ofertaEducativa',
		        		   'paginaOrigen':'listadoOfertaEducativa'
		        		}
		      	})
		      .then(rs => rs.json())
		      .catch(error => console.log('error:', error))
		      .then(rs => {
		        if(rs.status == 200){
		        	this.gradoEducativo = rs.result.gradoEducativo;
		        	this.modalidades = rs.result.modalidades
	  	        }
		    });
		},

		ObtenerInfoTabla(id,tipo, nombre){

			if (tipo == 'grados'){ $('#tablaGrados tbody').removeClass('is-selected')}
			if (tipo == 'modalidades'){ $('#tablaModalidades tbody').removeClass('is-selected')}
			
			if(tipo == 'grados'){
				this.paginaCabecera ='ProgramaEducativo';
				this.resumenGradoEducativo = nombre;
			}
			 else{
			 	this.paginaCabecera = 'DetalleModalidad';
			 	this.resumenModalidad = nombre;
			 }
		
			fetch(`${BASE.baseUrl}api/FiltroCatalogo/${id}`, {
		        method: 'GET',
		        headers: {
		        		   'Authorization': sessionStorage.getItem('token'),
		        		   'pagina': this.paginaCabecera
		        		}
		      	})
		      .then(rs => rs.json())
		      .catch(error => console.log('error:', error))
		      .then(rs => {
		        if(rs.status == 200){
		        	if(tipo == 'grados'){this.datosTablaGrados = []} else{this.datosTablaModalidades = []}

		        	rs.result.listado.forEach((item, indx) => {
		        		if(tipo == 'grados'){
			           		this.datosTablaGrados.push(item);
			           	}else{
			           		this.datosTablaModalidades.push(item);
			           	}
			        });
				}
		    });
		},

		ObtenerOfertaEducativa(){

			var idOferta = this.idOferta;
      		fetch(`${BASE.baseUrl}api/ObtenerOferta/${idOferta}`, {
          	method: 'GET',
          	headers: {
            'Authorization': sessionStorage.getItem('token'),
            'pagina': 'ofertaEducativa'
	        }
		    })
		      .then(rs => rs.json())
		      .catch(error => console.log('error:', error))
		      .then(rs => {
		        if(rs.status == 200){
		            this.ObtenerInfoTabla(rs.result.idGradoEducativo,'grados', rs.result.nombreGradoEducativo);
		          
		            this.idProgramaEducativo = rs.result.idProgramaEducativo;
		        	this.idDetalleModalidad = rs.result.idDetalleModalidad;
		        	this.idModalidad = rs.result.idModalidad;

		        	this.resumenGradoEducativo = rs.result.nombreGradoEducativo;
					this.resumenProgramaEducativo = rs.result.nombreProgramaEducativo;
					this.resumenModalidad =rs.result.nombreModalidad; 
					this.resumenDetalleModalidad = rs.result.nombreDetalleModalidad;

		            var id = this.idProgramaEducativo;
		            setTimeout(() => { $('#A_' + id).addClass('is-selected')},1000); 
		            
		          }
		    });
		},

		handleSelectedGrado(tr) {
		
			$('#A_' + this.idProgramaEducativo).removeClass('is-selected')
			this.GradoValidacion = "";
			this.idProgramaEducativo = `${tr.id}`;
			this.resumenProgramaEducativo = `${tr.nombre}`;
   		},

   		handleSelectedModalidad(tr) {
   			
   			$('#B_' + this.idDetalleModalidad).removeClass('is-selected')
   			this.ModalidadValidacion ='';
   			this.idDetalleModalidad =  `${tr.id}`;
			this.resumenDetalleModalidad = `${tr.nombre}`;
   		},

   		Siguiente(){
			if (this.contadorSiguiente == 0){
				if (this.idProgramaEducativo > 0){
					$('#divGradoEducativo').css('display','none');
			  	 	$("#divModalidad").fadeToggle('slow');

					if (this.idOferta !=0 && this.contadorEdicion == 0) {
						this.ObtenerInfoTabla(this.idModalidad,'modalidades', this.resumenModalidad);
 						setTimeout(() => { $('#B_' + this.idDetalleModalidad).addClass('is-selected')},1000); 
					};

				}else{
					this.contadorSiguiente --;
	  		 		this.GradoValidacion = "* Debes seleccionar un grado";
	  		  	}
	 		}
 			if (this.contadorSiguiente == 1){
 				if(this.idDetalleModalidad > 0){
	 				$('#divModalidad').css('display','none');
	 				$("#divResumen").fadeToggle('slow');
	 				$('#botonSiguiente').css('display','none');
	 				$('#botonGuardar').css('display','block');
	 			}else{
	 				this.contadorSiguiente --;
	 				this.ModalidadValidacion = "* Debes seleccionar una modalidad";
	 			}
 			}
 			this.contadorSiguiente ++; 
 			this.contadorEdicion ++;
   		},

   		Anterior(){
   		
			if (this.contadorSiguiente == 1){
				$('#divModalidad').css('display','none');
				$("#divGradoEducativo").fadeToggle('slow');
			}
  		 	
  		 	if (this.contadorSiguiente == 2){
	  		 	$("#divResumen").css('display','none');	
	  		 	$('#divModalidad').fadeToggle('slow');
	  		 	$('#botonGuardar').css('display','none');
	  		 	$('#botonSiguiente').css('display','block');
  		 	}

			this.contadorSiguiente --;
   		}, 

   		GuardarOferta(){
			
			var objeto = {
				'idProgramaEducativo': this.idProgramaEducativo,
			    'idDetalleModalidad':this.idDetalleModalidad
	  		}
	  	
			fetch(`${BASE.baseUrl}api/AgregarOfertaEducativa`, {
			method: 'POST',
        	headers: {
        		'Authorization': sessionStorage.getItem('token'),
        		'pagina':'ofertaEducativa',
        		'Content-Type':'application/json'
        	},
        	body: JSON.stringify(objeto),
			})
			.then(rs => rs.json())
			.catch(error => console.log('error:', error))
			.then(rs => {
		 		this.MostrarMensaje(rs.status)
			})
   		},

   		EditarOferta(){
			
			var objeto = {
				'idOfertaEducativa':this.idOferta,
				'idProgramaEducativo': this.idProgramaEducativo,
			    'idDetalleModalidad':this.idDetalleModalidad
	  		}
	  		  	
			fetch(`${BASE.baseUrl}api/EditarOferta`, {
			method: 'POST',
        	headers: {
        		'Authorization': sessionStorage.getItem('token'),
        		'pagina':'ofertaEducativa',
        		'Content-Type':'application/json'
        	},
        	body: JSON.stringify(objeto),
			})
			.then(rs => rs.json())
			.catch(error => console.log('error:', error))
			.then(rs => {
		 		this.MostrarMensaje(rs.status)
			})
   		
   		},

   		//MUESTRA EN MENSAJE DE LA RESUESTA
		MostrarMensaje(idResupesta){
			
			switch(idResupesta){
				case 200:
					this.$vs.notify({color:'success',title:'Exitoso',text:'El registro se ha guardado correctamente.'})
					this.$router.push('/OfertaEducativa') ; 
					break;
				case 207:
					this.$vs.notify({color:'warning',title:'Alerta',text:'La oferta que se quiere registrar ya existe.'})
					break;
				case 427:
					this.$vs.notify({color:'warning',title:'Alerta',text:'No tiene permisos para esta acción.'})
					break;
				case 429:
					this.$vs.notify({color:'warning',title:'Alerta',text:'Datos incorrectos'})
					break;
				case 500:
					this.$vs.notify({color:'danger',title:'Error',text:'Ha ocurrido un error. Favor de ponerse en contacto con el administrador.'})
					break;
				default:
					this.$vs.notify({color:'warning',title:'Alerta',text:'Favor de ponerse en contacto con el administrador.'})
					break;
			}	
		},
	},
	components: {
		Prism,
		VuePerfectScrollbar
	},
	mounted() {
		$('.includeIcon').css('display','none');
  		this.ObtenerInformacionPrograma();

  		this.idOferta = this.$route.params.idOferta;
    	if (this.idOferta !=0){ this.ObtenerOfertaEducativa()}
	},

}